import React, { useEffect, useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { EditIcon, SettingIcon } from "../../../SvgIconsData";
import ResponseModal from "./ResponseModal";
import FeedbackDetail from "./FeedbackDetail";
import responimg from "../../../assets/img/responses.png";
import ProPopup from "../../../pages/ProPopup";
import { CrownIcon, LineIcon, ResponseIcon } from "../../../assets/Icons";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { FEEDBACK_MANAGE_PERMISSION } from "../../../constant/permission";
import { checkPermissionExist } from "../../../utils/general";
import apiClient from "../../../apiClient";
const { useUnoSelector } = UnoStoreHooks;

const FeedBackList = () => {
  const [selectedFeedback, setSelectedFeedback] = useState(true);
  const [isChecked, setIsChecked] = useState({});
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [activeTab, setActiveTab] = useState("summary");
  const [feedBackList, setFeedBacks] = useState([]);
  const [responses, setResponses] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [typef, setTypef] = useState("Feedback");
  const [loading, setLoading] = useState(true);
  const skeletonNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const itemsPerPage = 10;

  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const navigate = useNavigate();

  const { type } = useParams();

  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    if (userData?.plans?.data) setUserPlan(userData.plans.data);
  }, [userData]);

  const handleChange = async (uuid) => {
    const updatedFeedbackList = feedBackList.map((feedback) => {
      if (feedback.uuid === uuid) {
        feedback.status = feedback.status === "LIVE" ? "PAUSED" : "LIVE";
      }
      return feedback;
    });

    setFeedBacks(updatedFeedbackList);

    let data = await apiClient.get(`${configData.config.UNO_URL}/api/feedback/change/status/${uuid}`);

    // const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/change/status/${uuid}`, {
    //   headers: {
    //     Authorization: `Bearer ${userData.token}`,
    //   }});

    setFeedBacks(data || []);
  };

  const handleClose = () => setShow(false);
  const handleShow = (feedback) => {
    setShow(true);
    setActiveTab("summary");
    setResponses(feedback || []);
  };

  const feedbackByChannel = async () => {
    try {

      let data = await apiClient.get(`${configData.config.UNO_URL}/api/feedback/getFeedbackByChannel`);

      // const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/getFeedbackByChannel`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   }});

      setLoading(false);
      setFeedBacks(data || []);
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  };
  useEffect(() => {
    feedbackByChannel();
  }, [type]);

  const pageCount = Math.ceil(feedBackList.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentPageData = feedBackList.slice(offset, offset + itemsPerPage);

  const sortType = () => {
    const sortedList = [...feedBackList];
    sortedList.sort((a, b) => {
      if (sortOrder === "asc") {
        return a.type.localeCompare(b.type);
      }
      return b.type.localeCompare(a.type);
    });
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setFeedBacks(sortedList);
  };
  const PrevArrow = () => (
    <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.90918 22C5.1996 19.3872 8.16422 16.3109 10.7274 12.85C11.091 12.35 11.091 11.65 10.7274 11.15C8.16422 7.68908 5.1996 4.61284 1.90918 2"
        stroke="#2F3A79"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const NextArrow = () => (
    <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0908 2C7.8004 4.61284 4.83578 7.68908 2.27256 11.15C1.90899 11.65 1.90899 12.35 2.27256 12.85C4.83578 16.3109 7.8004 19.3872 11.0908 22"
        stroke="#2F3A79"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
      <div className=" feedbackfgg ">
        {selectedFeedback ? (
          <div className=" mt-2">
            <div className="card">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-md-12 ">
                    <div className="table-responsive workflowtb stickyhead">
                      <table className="table align-middle table-nowrap mb-0 p-4">
                        <thead style={{ position: "sticky", top: 0, zIndex: "5" }}>
                          <tr className="feedback-header">
                            <th className="text-center">S.No.</th>
                            <th> Title</th>
                            <th className="text-center d-block">
                              Type
                              <span onClick={sortType} className="cursor-pointer">
                                <SwapVertIcon />
                              </span>
                            </th>
                            <th className="text-start" style={{ whiteSpace: "nowrap" }}>
                              Date & time
                            </th>
                            <th className="text-center">Responses </th>
                            <th className="text-center">Manage </th>
                            {checkPermissionExist(FEEDBACK_MANAGE_PERMISSION) && (
                              <th style={{ whiteSpace: "nowrap", textAlign: "center" }}>Activity status</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <>
                              {skeletonNumbers.map((index) => (
                                <tr key={index}>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td className="text-center">
                                    <Skeleton />
                                    <Skeleton width="70px" height="12px" />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            currentPageData.map((item, index) => (
                              <>
                                <tr key={item.id}>
                                  <td className="text-center ">{index + 1}</td>

                                  <td>
                                    <div className="feedbackitleff">
                                      <OverlayTrigger placement="top" overlay={<Tooltip>{item.name}</Tooltip>}>
                                        <p className="m-0">{item.name}</p>
                                      </OverlayTrigger>
                                    </div>
                                  </td>

                                  <td className="text-center">
                                    <span
                                      className={` ${
                                        item.type === "FEEDBACK"
                                          ? "text-success bg-light-success"
                                          : "text-danger bg-light-danger"
                                      }`}
                                    >
                                      {item.type.charAt(0).toUpperCase() + item.type.slice(1).toLowerCase()}
                                    </span>
                                  </td>
                                  <td className="text-start font-weight-bold">
                                    <p className="m-0 line-height1 font-weight-bold">
                                      {moment(item.createdAt).format("DD/MM/YYYY")}
                                    </p>
                                    <span className="font-xsss m-0 font-weight-bold">
                                      {moment(item.createdAt).format("hh:mm A")}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip> {item?.responses?.length > 0 ? "View" : "No"} Responses</Tooltip>
                                      }
                                    >
                                      <span
                                        className="cursor-pointer msg-btn"
                                        onClick={item?.responses?.length > 0 ? () => handleShow(item) : null}
                                      >
                                        <ResponseIcon />({item?.responses?.length || 0})
                                      </span>
                                    </OverlayTrigger>
                                  </td>
                                  <td>
                                    <div className="actionbtn d-flex justify-content-center aligin-item-center gap-3 ">
                                      {checkPermissionExist(FEEDBACK_MANAGE_PERMISSION) && (
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit Feedback</Tooltip>}>
                                          <div
                                            className="cursor-pointer gap-2"
                                            onClick={() =>
                                              navigate(`/feedback/create/${item.uuid}`, {
                                                state: { key: "feedbacklist", type },
                                              })
                                            }
                                          >
                                            <EditIcon />
                                          </div>
                                        </OverlayTrigger>
                                      )}
                                      <LineIcon />
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>{item?.responses?.length > 0 ? "View" : "No"} Detail</Tooltip>
                                        }
                                      >
                                        <div
                                          className="cursor-pointer colorbtn"
                                          onClick={
                                            item?.responses?.length > 0
                                              ? () =>
                                                  navigate(`/feedback/feedback/detail/${item.uuid}`, {
                                                    state: { key: "feedbacklist", type },
                                                  })
                                              : null
                                          }
                                        >
                                          <RemoveRedEyeOutlinedIcon />
                                        </div>
                                      </OverlayTrigger>

                                      <LineIcon />
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            <div className="text-start">
                                              <span>Users shared with: {item?.invites?.length || 0}</span> <br />
                                              <span>Total responses: {item?.responses?.length || 0}</span>
                                            </div>
                                          </Tooltip>
                                        }
                                      >
                                        <div className="cursor-pointer">
                                          <img src={responimg} style={{ width: "20px" }} alt="" />
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  </td>

                                  {checkPermissionExist(FEEDBACK_MANAGE_PERMISSION) && (
                                    <td>
                                      <div className="d-flex gap-2 align-items-center justify-content-center">
                                        {item.publishTime === null ? (
                                          <span style={{ color: "#d01119" }}>
                                            <strong>Draft</strong>
                                          </span>
                                        ) : (
                                          <>
                                            <span className={`text-${item.status === "LIVE" ? "success" : "danger"}`}>
                                              {" "}
                                              <strong>
                                                {item.status.charAt(0).toUpperCase() +
                                                  item.status.slice(1).toLowerCase()}
                                              </strong>{" "}
                                            </span>
                                            <div className="form-check form-switch">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={item.status === "LIVE"}
                                                onChange={() => handleChange(item.uuid)}
                                                id={item.id}
                                              />
                                            </div>
                                          </>
                                        )}
                                        {/* <span className={`text-${item.status === 'LIVE' ? 'success' : 'danger'}`}>
                                      <strong>
                                        {item.status === 'LIVE' && item.publishTime && item.expiryTime ? 'LIVE' : (
                                          <span style={{ color: 'red' }}>Unpublished</span>
                                        )}
                                      </strong>
                                    </span> */}
                                        {/* <OverlayTrigger placement="top" overlay={<Tooltip>Click to switch status</Tooltip>}>
                                      <div style={{ width: '30px' }}>
                                        {item.status === 'LIVE' || item.status === 'PAUSED' ? (
                                          item.expiryTime && item.publishTime ? (
                                            <div className="form-check form-switch">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={item.status === 'LIVE'}
                                                onChange={() => handleChange(item.uuid)}
                                                id={item.id}
                                              />
                                            </div>
                                          ) : null
                                        ) : null}
                                      </div>
                                    </OverlayTrigger> */}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              </>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <span onClick={() => setSelectedFeedback(true)} className="cursor-pointer backfg">
              <KeyboardBackspaceOutlinedIcon className="font-md" />
            </span>
            <FeedbackDetail />
          </div>
        )}
        {!loading && (
          <ReactPaginate
            pageCount={pageCount}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            containerClassName="pagination"
            activeClassName="active"
            previousLabel={<NextArrow />}
            nextLabel={<PrevArrow />}
            previousClassName="prevBtn"
            nextClassName="nextBtn"
            disabledClassName="disabled"
          />
          //  <ReactPaginate
          //   pageCount={pageCount}
          //   onPageChange={({ selected }) => setCurrentPage(selected)}
          //   containerClassName="pagination"
          //   activeClassName="active"
          //   previousLabel={<FaArrowLeft />}
          //   nextLabel={<FaArrowRight />}
          //   previousClassName="prevBtn"
          //   nextClassName="nextBtn"
          //   disabledClassName="disabled"
          // />
        )}
        <ResponseModal show={show} handleClose={handleClose} activeTab={activeTab} responses={responses || []} />
      </div>

      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default FeedBackList;
